import * as React from 'react';

import { useFeatures } from 'src/providers/FeatureProvider';

import { PrimaryButton } from './PrimaryButton';
import { InvertedButton } from './InvertedButton';

type InvertibleButtonProps = React.ComponentPropsWithoutRef<'button'>;

export const InvertibleButton = React.forwardRef<HTMLButtonElement, InvertibleButtonProps>((props, ref) => {
  const { invertColors } = useFeatures();

  return invertColors ? <InvertedButton {...props} ref={ref} /> : <PrimaryButton {...props} ref={ref} />;
});

InvertibleButton.displayName = 'InvertibleButton';
